import { t } from "i18next";

export const tableStyles = {
    headRow: {
        style: {
            backgroundColor: '#06a099',
        },
    },
    headCells: {
        style: {
            fontWeight: 'bold',
            color: '#ffffff',
            backgroundColor: '#06a099'
        },
    }
};

export const getPaginationOptions = () => ({
    rowsPerPageText: t("Rows per page:"),
    rangeSeparatorText: t("of")
});